<template>
    <gofix-card title="Workers" fullContent classContent="mb-0">
        <gofix-table 
            class="noFullHeight scrollAbsolute"
            :settings="tableConfig"
            :table-items="tableItems"
            @new-item="newItem"
            @delete-items="deleteItems"
            @load-items="getTableData"
            ref="gofixTable">
        </gofix-table>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Worker" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-input-number 
                            label="Temparature" 
                            v-model="modals.add.data.temperature" 
                            :integer-limit="2" 
                            :include-thousands-separator="false" 
                            :rows="5"
                            :allowDecimal="true" class="gofixInputNoMinWidth">
                        </gofix-form-input-number>
                        <gofix-form-dropdown
                            label="Workers"
                            vLabel="user_name"
                            class="mb-3"
                            @search="searchWorker"
                            :filterable="false"
                            :required="!modals.add.data.is_new_worker"
                            :show-icon-required="!modals.add.data.is_new_worker"
                            :disabled="modals.add.data.is_new_worker"
                            :reduce="option => option.id"
                            v-model="modals.add.data.safety_worker_id"
                            :options="modals.add.options.workers">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.name}} - {{option.ic_fin}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.name}} - {{option.ic_fin}}
                            </template>
                        </gofix-form-dropdown>
                        <div class="d-flex">
                            <b-form-checkbox v-model="modals.add.data.is_new_worker" class="checkbox-main-allow mt-0">
                                <span>Allow a new Worker</span>
                            </b-form-checkbox>
                        </div>
                        <div class="mt-3" v-if="modals.add.data.is_new_worker">
                            <gofix-form-input 
                                label="Name" 
                                required
                                show-icon-required
                                v-model="modals.add.data.name">
                            </gofix-form-input>
                            <gofix-form-input 
                                label="IC/FIN" 
                                required
                                show-icon-required
                                v-model="modals.add.data.ic_fin">
                            </gofix-form-input>
                            <gofix-form-input 
                                label="Department" 
                                v-model="modals.add.data.department">
                            </gofix-form-input>
                            <gofix-form-input 
                                label="Company" 
                                v-model="modals.add.data.company">
                            </gofix-form-input>
                        </div>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'

export default {
    name: 'safety-workers-listing',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_workers_listing']));
        return {
            tableConfig:{
                name: 'safety-workers-listing-2',
                controls:{
                    create: this.$checkRole(this.$accessModule.toolbox_meeting, 'update'),
                    delete: this.$checkRole(this.$accessModule.toolbox_meeting, 'update'),
                    tableImport: false,
                    tableExport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "asc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Attended', text: 'Attended'}
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width:50px",
                    },
                    {
                        key: 'safety_worker_id',
                        label: 'ID',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:100px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'ic_fin',
                        label: 'IC/FIN',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'department',
                        label: 'Department',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'company',
                        label: 'Company',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'temperature',
                        label: 'Temperature',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    // {
                    //     key: 'status',
                    //     label: 'Status',
                    //     isActive: 1,
                    //     isFilter: true,
                    //     thStyle: "width:auto",
                    //     sorting: true,
                    //     with:null
                    // }
                ],
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        safety_job_id: null,
                        safety_worker_id: null,
                        is_new_worker: false,
                        name: null,
                        ic_fin: null,
                        department: null,
                        company: null,
                        temperature: null,
                    },
                    options: {
                        workers: [],
                        scontracts: [],
                        topics: [],
                    }
                }
            },
            timer: {
                scontracts: null,
                workers: null,
                save: null
            },
        }
    },
    computed: {
        ...mapGetters({
            Item: 'SafetyAppController/safetyJob',
        }),
    },
    watch: {
        "modals.add.data.is_new_worker": function(val) {
            if(val) {
                this.modals.add.data.safety_worker_id = null;
                this.modals.add.data.name = null;
                this.modals.add.data.ic_fin = null;
                this.modals.add.data.department = null;
                this.modals.add.data.company = null;
            }
        },
        Item: function(val) {
            this.updateAdd();
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.safety_job_id = this.$route.params.id
                await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of attendees", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },
        async updateAdd () {
            if(this.Item && this.Item.id) {
                this.tableConfig.controls.create = this.$checkRole(this.$accessModule.toolbox_meeting, 'update');
                this.tableConfig.controls.delete = this.$checkRole(this.$accessModule.toolbox_meeting, 'update');
                if(this.Item.status && !['New'].includes(this.Item.status)) {
                    this.tableConfig.controls.create = false;
                    this.tableConfig.controls.delete = false;
                }

                this.$nextTick(() => {
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateCreateBT()
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateDeletedBT()
                });
            }
            
        },
        clickToRowItem(item) {
           this.$router.push(`/v2/safety-induction-training/${item.id}`)
        },
        newItem() {
            this.modals.add.data = {
                safety_job_id: this.Item.id,
                safety_worker_id: null,
                is_new_worker: false,
                name: null,
                ic_fin: null,
                department: null,
                company: null,
                temperature: null,
            };
            this.getWorkers()
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteWorkerForToolboxMeetingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safety_worker'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        async getWorkers(search = '') {
            let tableRequest = {
                filter: { search: search },
                page: 1,
                limit: 100
            }

            await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                .then(response => {
                    this.modals.add.options.workers = response.items;
                })
                .catch(err => {})
        },
        async searchWorker(search, loading) {
            loading(true)
            this.modals.add.options.workers = []
            if (this.timer.workers) {
                clearTimeout(this.timer.workers);
                this.timer.workers = null;
            }
            this.timer.workers = setTimeout(async () => {
                try {
                    await this.getWorkers(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;
                
                if(!this.modals.add.data.is_new_worker && !this.modals.add.data.safety_worker_id) {
                    return this.$alertNotification("Please choose a worker.", "danger");
                }

                if(this.modals.add.data.is_new_worker) {
                    if(!this.modals.add.data.name) {
                        return this.$alertNotification("Please choose a date.", "danger");
                    }

                    if(!this.modals.add.data.ic_fin) {
                        return this.$alertNotification("Please enter venue.", "danger");
                    }
                }
                
                this.$store.dispatch("SafetyAppController/createWorkerForToolboxMeetingItem", this.modals.add.data)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    this.$alertNotification(this.$notificationV2('adding', 'safety_worker'), "success");
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        this.updateAdd();
    }
}
</script>